import Select from 'react-select'
import React, { useEffect, useState } from 'react'
// import { DailyPreventiveWorkTableDataAPI } from "../../../../Redux/GardenDashboardSlice/DailyPreventiveWorkSlice";
import moment from "moment";
import { useAuthState } from '../../../../../Helper/Context';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Header from '../../../../../Components/Header/Header';
import Sidebar from '../../../../../Components/Sidebar/Sidebar';
import { WardNameDataDDL } from '../../../../../Components/CommonDDL/WardNameDataDDL';
import { ProjectTypeDataDDL } from '../../../../../Components/CommonDDL/ProjectTypeDataDDL';
import { ProjectNameDataDDL } from '../../../../../Components/CommonDDL/ProjectNameDataDDL';
import { MonthHeaderDDL } from '../../../../../Components/CommonDDL/MonthHeaderDDL';
import { Pegination } from '../../../../../Components/Pegination/Pegination';
import { MonthDataDDL } from '../../../../../Components/CommonDDL/MonthDataDDL';
import { MainPanelityReportTableDataAPI } from '../../../../../Redux/ReportsSlice/WaterSupplyMainPanelityReportSlice';
import { toastErrorr } from '../../../../../Helper/ToastMessage';
import { ReportProjectTypeDataDDL } from '../../../../../Components/CommonDDL/ReportProjectTypeDataDDL';
import { ReportProjectNameDataDDL } from '../../../../../Components/CommonDDL/ReportProjectNameDataDDL';
import { ReportWardNameDataDDL } from '../../../../../Components/CommonDDL/ReportWardNameDataDDL';
import { FinancialYearDataDDL } from '../../../../../Components/CommonDDL/FinancialYearDataDDL';
import { Loading } from '../../../../../Helper/Loading';
import { ALLMainPanelityPDFReportTableDataAPI } from '../../../../../Redux/ReportsSlice/AllPDFReportSlice';
import { AstricSign } from '../../../../../Helper/AstricSign';

export default function CommonAllDashboardReport() {

    const userDetails = useAuthState();
    const { year, setYear, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let ReportName = searchParams.get("ReportName")


    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeDDL = searchParams.get("ProjectTypeDDL")

    const d = new Date();
    let month = d.getMonth();

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        // ID: HYear && HYear ? HYear : '0',
        // Label: YLable && YLable ? YLable : "Select...",
        ID: 0,
        Label: "Select...",
    })

    const [Month, setMonth] = useState({
        DDL: [],
        ID: HMonth && HMonth ? HMonth : '0',
        Label: MLable && MLable ? MLable : "Select...",
    });

    const [ReportWardName, setReportWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ReportProjectName, setReportProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ReportProjectType, setReportProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [FromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [ImageHeading, setImageHeading] = useState('')
    const [PDFUrl, setPDFUrl] = useState('')
    const [GridData, setGridData] = useState([])


    const handleClear = () => {
        setCurrentPage(0)
        setIsClear(!IsClear)
        setGridData([])
        setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        setToDate(moment().format('YYYY-MM-DD'))
        setReportWardName({
            ...ReportWardName,
            ID: 0,
            Label: 'Select...',
        })
        setReportProjectType({
            ...ReportProjectType,
            ID: ReportName === 'Road - Main Penalty Report' ? ReportProjectType.DDL[3].value : DashProjectTypeId == 1 ? ReportProjectType.DDL[0].value : DashProjectTypeId == 6 ? ReportProjectType.DDL[5].value : ProjectTypeDDL === 'Sewerage' ? ReportProjectType.DDL[1].value : ProjectTypeDDL === 'STP' ? ReportProjectType.DDL[2].value : ProjectTypeDDL === 'Garden' ? ReportProjectType.DDL[4].value : DashProjectTypeId == 7 ? ReportProjectType.DDL[6].value : 0,
            Label: ReportName === 'Road - Main Penalty Report' ? ReportProjectType.DDL[3].label : DashProjectTypeId == 1 ? ReportProjectType.DDL[0].label : DashProjectTypeId == 6 ? ReportProjectType.DDL[5].label : ProjectTypeDDL === 'Sewerage' ? ReportProjectType.DDL[1].label : ProjectTypeDDL === 'STP' ? ReportProjectType.DDL[2].label : ProjectTypeDDL === 'Garden' ? ReportProjectType.DDL[4].label : DashProjectTypeId == 7 ? ReportProjectType.DDL[6].label : "Select...",
        })
        setFinancialYear({
            ...FinancialYear,
            ID: FinancialYear.DDL[0].value,
            Label: FinancialYear.DDL[0].label
        })
        // setMonth({
        //     ...Month,
        //     ID: Month.DDL[month].value ? Month.DDL[month].value : '0',
        //     Label: Month.DDL[month].label ? Month.DDL[month].label : "Select...",
        // })
        setMonth({
            ...Month,
            ID: Month?.DDL[month]?.value ? Month?.DDL[month]?.value : '0',
            Label: Month?.DDL[month]?.label ? Month?.DDL[month]?.label : "Select...",
        })
        setReportProjectName({
            ...ReportProjectName,
            ID: 0,
            Label: 'Select...'
        })

    }

    const handlePost = () => {
        setIsPost(!IsPost)
    }

    const handleGetPDFUrl = (pdfUrl) => {
        // console.log('pdfUrl',pdfUrl)
        if (pdfUrl && pdfUrl != '') {
            window.open(pdfUrl)
            // setPDFUrl(pdfUrl)
        } else {
            toastErrorr("PDF not found")
        }
    }

    const handleOpenPdf = () => {
        window.open(PDFUrl)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handleGetPDF = () => {

        const data = {
            M_ProjectTypeID: DashProjectTypeId == '6' ? '6' : DashProjectTypeId == '1' ? '1' : ProjectTypeId == '2' ? '2'
                : ProjectTypeId == '3' ? '3' : ProjectTypeId == '4' ? '4' : DashProjectTypeId == '7' ? '7' : '5',
            M_FinancialYearID: FinancialYear.ID,
            M_MonthID: Month.ID,
            FromDate: FromDate,
            Todate: ToDate,
            M_ContractorID: 0,
            M_ProjectID: ReportProjectName.ID,
            M_WardID: ReportWardName.ID,
            UserID: UserID,
            token: token,
            Flag: 'PDF_Report',
            handleGetPDFUrl: handleGetPDFUrl
        }
        dispatch(ALLMainPanelityPDFReportTableDataAPI({ data }))
    }

    useEffect(() => {
        const data = {
            M_ProjectTypeID: DashProjectTypeId == '6' ? '6' : DashProjectTypeId == '1' ? '1' : ProjectTypeId == '2' ? '2'
                : ProjectTypeId == '3' ? '3' : ProjectTypeId == '4' ? '4' : DashProjectTypeId == '7' ? '7' : '5',
            M_FinancialYearID: FinancialYear.ID,
            M_MonthID: Month.ID,
            FromDate: FromDate,
            Todate: ToDate,
            M_ContractorID: 0,
            M_ProjectID: ReportProjectName.ID,
            M_WardID: ReportWardName.ID,
            UserID: UserID,
            token: token,
            Flag: 'Grid',
            setGridData: setGridData,
        }

        if (ReportName == 'Water Supply - Distribution Penalty Report') {
            if (ReportWardName.ID != 0) {
                dispatch(MainPanelityReportTableDataAPI({ data }))
            }
        }
        // if (ReportName == 'Water Supply - Main Penalty Report') {
        //     dispatch(MainPanelityReportTableDataAPI({ data }))
        // }
        dispatch(MainPanelityReportTableDataAPI({ data }))

    }, [IsPost, To, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.MainPanelityReportTableData)

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ReportWardName.ID, FromDate, ToDate])

    // console.log('current', moment().format('YYYY'),)
    // // console.log('previous', moment().subtract(1).format('YYYY'),)
    // console.log('previous', moment().subtract(1, 'years').format('YYYY'))

    // console.log('Current Financial Year Starting', moment().month('april').startOf('month').format('YYYY-MM-DD'))
    // console.log('Current Financial Year Ending', moment().add(1, 'years').month('march').endOf('month').format('YYYY-MM-DD'))

    // console.log('Previous Financial Year Starting', moment().subtract(1, 'years').month('april').startOf('month').format('YYYY-MM-DD'))
    // console.log('Previous Financial Year Ending', moment().month('march').endOf('month').format('YYYY-MM-DD'))

    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        ProjectTypeDDL={ProjectTypeDDL}
                        active='commonalldashboardreport'
                        listActive={(ProjectTypeId == 1 || ProjectTypeId == 6) ? "waterreport" || "wtpreport" : ProjectTypeId == 7 ? "wtpreport" : ProjectTypeId == 2 ? "Seweragereport" : ProjectTypeId == 3 ? "stpreport" : ProjectTypeId == 4 ? "roadReport" : ""}
                    />
                    <div id="" className="content1 content">
                        <div className="data_mob">
                            <div className="row m-1 pb-4 master_border">
                                <div className="col-8">
                                    <h5 className="ps-1 py-2">
                                        {
                                            DashProjectTypeId == 9 ?
                                                "TTP - Distribution Penalty Report"
                                                :
                                                "ReportName"
                                        }
                                    </h5>
                                </div>
                                <div className="col-4 mt-2">
                                    {
                                        GridData && GridData.table && GridData.table.length > 0 ?
                                            <>
                                                {/* <button type="button" className="btn btn-primary float-end mr-1">Export</button> */}
                                                <button type="button" className="btn btn-danger float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                                                    onClick={handleGetPDF}
                                                ><i className='fas fa-file-pdf mx-2'></i>PDF</button>
                                            </>
                                            :
                                            ''

                                    }

                                </div>
                                <div className="row m-0">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">
                                            <div className="row py-1 rounded2">
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <FinancialYearDataDDL
                                                        FinancialYear={FinancialYear}
                                                        setFinancialYear={setFinancialYear}
                                                        HYear={HYear}
                                                        YLable={YLable}
                                                        Flag='PenealtyReport'
                                                        isCompulsory={true}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"> <b>From Date :<AstricSign /></b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="FromDate"
                                                            value={FromDate}
                                                            min={
                                                                (moment().format('YYYY') == FinancialYear.ID) ?
                                                                    moment().month('april').startOf('month').format('YYYY-MM-DD')
                                                                    :
                                                                    moment().subtract(1, 'years').month('april').startOf('month').format('YYYY-MM-DD')
                                                            }
                                                            max={
                                                                (moment().format('YYYY') == FinancialYear.ID) ?
                                                                    moment().add(1, 'years').month('march').endOf('month').format('YYYY-MM-DD')
                                                                    :
                                                                    moment().month('march').endOf('month').format('YYYY-MM-DD')
                                                            }
                                                            disabled={
                                                                FinancialYear.ID == 0
                                                            }
                                                            onChange={(e) => setFromDate(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <div className="form-group">
                                                        <label className="d-block" htmlFor="NameofDepartment"><b>To Date :<AstricSign /></b></label>
                                                        <input type="date"
                                                            className="form-control"
                                                            id="ToDate"
                                                            value={ToDate}
                                                            min={
                                                                (moment().format('YYYY') == FinancialYear.ID) ?
                                                                    moment().month('april').startOf('month').format('YYYY-MM-DD')
                                                                    :
                                                                    moment().subtract(1, 'years').month('april').startOf('month').format('YYYY-MM-DD')
                                                            }
                                                            max={
                                                                (moment().format('YYYY') == FinancialYear.ID) ?
                                                                    moment().add(1, 'years').month('march').endOf('month').format('YYYY-MM-DD')
                                                                    :
                                                                    moment().month('march').endOf('month').format('YYYY-MM-DD')
                                                            }
                                                            disabled={
                                                                FinancialYear.ID == 0
                                                            }
                                                            onChange={(e) => setToDate(e.target.value)} />

                                                    </div>
                                                </div>
                                                {
                                                    DashProjectTypeId == '1' &&
                                                    <div className="col-12 col-md-4 col-lg-3">
                                                        <MonthDataDDL
                                                            Month={Month}
                                                            setMonth={setMonth}
                                                            MLable={MLable}
                                                            HMonth={HMonth}
                                                            Flag='Month'
                                                            screenType='commonalldashboardreport'
                                                        />
                                                    </div>
                                                }

                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ReportProjectTypeDataDDL
                                                        ReportProjectType={ReportProjectType}
                                                        setReportProjectType={setReportProjectType}
                                                        ReportName={ReportName}
                                                        ProjectTypeDDL={ProjectTypeDDL}
                                                        DashProjectTypeId={DashProjectTypeId}
                                                        isDisabled={true} />
                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ReportProjectNameDataDDL
                                                        ReportProjectName={ReportProjectName}
                                                        setReportProjectName={setReportProjectName}
                                                        IsPost={IsPost}
                                                        ReportProjectType={ReportProjectType}
                                                        isCompulsory={true}
                                                    />

                                                </div>
                                                <div className="col-12 col-md-4 col-lg-3">
                                                    <ReportWardNameDataDDL
                                                        ReportWardName={ReportWardName}
                                                        setReportWardName={setReportWardName}
                                                        ReportProjectType={ReportProjectType}
                                                        ReportProjectName={ReportProjectName}
                                                        isCompulsory={true}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-4 col-lg-3 mt-lg-4 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>

                                            <div className="row mob_table table-responsive pt-1">
                                                <table
                                                    id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th>Description Of KPI</th>
                                                            <th>Parameter</th>
                                                            <th>Bench Mark</th>
                                                            <th>Defaulter</th>
                                                            <th>Penalty (Rs.)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            GridData && GridData.table && GridData.table.length > 0 ? GridData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td>{item.kpI_Parameter ? item.kpI_Parameter : '-'}</td>
                                                                    <td>{item.parameter ? item.parameter : '-'}</td>
                                                                    <td>{item.benchMark ? item.benchMark : '-'}</td>
                                                                    <td>{item.defaulter ? item.defaulter : '-'}</td>
                                                                    <td>{item.totalPenalty ? item.totalPenalty : '-'}</td>

                                                                </tr>
                                                            )) :
                                                                <td colSpan={5}>No data found</td>
                                                        }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>

    )

}